// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._1mtFy{margin:auto}", ""]);
// Exports
exports.locals = {
	"container": "_1mtFy"
};
module.exports = exports;
